import { Link } from 'react-router-dom'

// images
import Logo from '../../images/logo.png'

const ClickHandler = () => {
  window.scrollTo(10, 0)
}

const Footer = (props) => {
  return (
    <footer className="wpo-site-footer">
      <div className="wpo-upper-footer">
        <div className="container">
          <div className="row">
            <div
              className="col col-lg-4 col-md-6 col-sm-12 col-12 scroll-text-animation"
              data-animation="fade_from_bottom"
            >
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <img src={Logo} alt="blog" />
                </div>
                <p>
                 Ain Almansaf Ltd. Strong homes start with strong materials.
                </p>
              </div>
            </div>
            <div
              className="col col-lg-4 col-md-6 col-sm-12 col-12 scroll-text-animation"
              data-animation="fade_from_bottom"
            >
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Contact</h3>
                </div>
                <ul>
                  <li>info@ainalmansaf.com</li>
                                    <li> +(964) 750 406 6556</li>
                  <li>Iraq, Kurdistan Region, Erbil</li>
                  <li> </li>
                </ul>
              </div>
            </div>
            <div
              className="col col-lg-4 col-md-6 col-sm-12 col-12 scroll-text-animation"
              data-animation="fade_from_bottom"
            >
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Quick Link</h3>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/about">
                      <span className="rolling-text">About Us</span>{' '}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/services">
                      <span className="rolling-text">Home Supplies</span>{' '}
                    </Link>
                  </li> 
                  <li>
                    <Link onClick={ClickHandler} to="/projects">
                      <span className="rolling-text">Construction Materials</span>
                    </Link>
                  </li>
                  {/* <li><Link onClick={ClickHandler} to="/blog"><span className="rolling-text">Blog</span> </Link></li> */}
                  <li>
                    <Link onClick={ClickHandler} to="/contact">
                      <span className="rolling-text">Contact</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            {/* <div
              className="col col-lg-3 col-md-6 col-sm-12 col-12 scroll-text-animation"
              data-animation="fade_from_bottom"
            >
              <div className="widget newsletter-widget">
                <div className="widget-title">
                  <h3>Follow Us</h3>
                </div>
                <div className="social-widget">
                  <ul>
                    <li>
                      <a
                        href="https://www.facebook.com/share/1HwCHrp4jU/"
                        onClick={ClickHandler}
                        target="_blank" rel="noreferrer"
                      >
                                              <i className="ti-facebook"></i>
                      </a>
                     
                      <a
                        href="https://www.instagram.com/a.to.z.construction_iq/?igsh=MTNueHl3NXQwOTJqbQ%3D%3D#"
                        onClick={ClickHandler}
                        target="_blank" rel="noreferrer"
                      >
                        <i className="ti-instagram"></i>
                        
                      </a>
                     
                    </li>
                  </ul>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div className="wpo-lower-footer">
        <div className="container-fluid">
          <div className="row g-0">
            <div className="col col-lg-12 col-12">
              <p className="copyright">
                &copy; Ain Almansaf. All Rights Reserved.
              </p>
            </div>
            {/* <div className="col col-lg-6 col-12">
                            <ul className="right">
                                <li><Link onClick={ClickHandler} to="/privace"><span className="rolling-text">Privace & Policy</span> </Link></li>
                                <li><Link onClick={ClickHandler} to="/terms"><span className="rolling-text">Terms</span></Link></li>
                                <li><Link onClick={ClickHandler} to="/about"><span className="rolling-text">About us</span></Link></li>
                                <li><Link onClick={ClickHandler} to="/login"><span className="rolling-text">Login</span></Link></li>
                            </ul>
                        </div> */}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
